import { Container } from '@mantine/core';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../../layout/header';
import { MainBody } from '../../layout/styles';
import Footer from '../../layout/footer';
import { useSelector } from 'react-redux';
import { getClientSlug } from '../../store/clientSlug.slice';
import { getSettingsState } from '../../store/settings.slice';

export default function Home() {
  const { pathname } = useLocation();
  const clientSlug = useSelector(getClientSlug);
  const settings = useSelector(getSettingsState);

  return (
    <>
      <Header showHeader={settings?.bgColor ? false : true} />
      <MainBody
        bgColor={settings?.bgColor}
        textColor={settings?.textColor}
        btnColor={settings?.btnColor}
        separatorColor={settings?.separatorColor}
        borderColor={settings?.borderColor}
        bgAvailableDaysColor={settings?.bgAvailableDaysColor}
        unavailableDaysColor={settings?.unavailableDaysColor}
        isInline={settings?.isInline}
        className="mainBody"
      >
        <div id="mainBody">
          <Outlet />
        </div>
      </MainBody>
      {/* <div
        style={{
          display:
            decodeURIComponent(pathname) === `/${clientSlug}`
              ? 'inline-block'
              : 'none',
          marginTop: 'auto',
        }}
      >
        <Footer />
      </div> */}
    </>
  );
}
